module.exports = __webpack_public_path__ + "static/img/video_banner.6d5d796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/video_banner.jpg
// module id = Gg6J
// module chunks = 1